import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Apollo } from 'apollo-angular';
import { catchError, map, switchMap } from 'rxjs/operators';

import { findDistrictByAddressQuery } from '../gql-queries';
import { errorMessageParser } from '../../gql-client/error-message-parser';
import { ShowError } from '../notification/notification.actions';
import {
  loadDistrictsByAddress,
  loadDistrictsByAddressFailure,
  loadDistrictsByAddressSuccess
} from './district.actions';

@Injectable()
export class DistrictEffects {
  private actions$ = inject(Actions);
  private apollo = inject(Apollo);

  fetchLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDistrictsByAddress),
      switchMap(({ address }) =>
        this.apollo
          .query({
            query: findDistrictByAddressQuery,
            variables: {
              address
            },
            fetchPolicy: 'no-cache'
          })
          .pipe(
            map(result =>
              loadDistrictsByAddressSuccess({
                data: result.data.districtForAddress
              })
            ),
            catchError(err => [
              loadDistrictsByAddressFailure({
                error: new Error(err.message)
              }),
              new ShowError(errorMessageParser(err))
            ])
          )
      )
    )
  );
}
